// client/src/coms/interactions/InteractionHost.js
// One creation dialog and one channel browser for the whole app (mounted in ComsLayout, like ReportHost):
//   window.dispatchEvent(new CustomEvent('vox-interaction-create', { detail: { serverKey, kind, channelId, channelName, type, prefill } }))
//   window.dispatchEvent(new CustomEvent('vox-interaction-browse', { detail: { serverKey, kind, channelId, channelName, type } }))
// (interactionStore exports openInteractionCreator / openInteractionBrowser.)
import React, { useEffect, useState } from 'react';
import InteractionComposer from './InteractionComposer';
import InteractionBrowser from './InteractionBrowser';

export default function InteractionHost() {
  const [create, setCreate] = useState(null);
  const [browse, setBrowse] = useState(null);
  useEffect(() => {
    const onCreate = (e) => {
      const d = e && e.detail;
      if (d && d.serverKey && d.channelId) {
        setBrowse(null);
        setCreate({ ...d, at: Date.now() });
      }
    };
    const onBrowse = (e) => {
      const d = e && e.detail;
      if (d && d.serverKey && d.channelId) setBrowse({ ...d, at: Date.now() });
    };
    window.addEventListener('vox-interaction-create', onCreate);
    window.addEventListener('vox-interaction-browse', onBrowse);
    return () => {
      window.removeEventListener('vox-interaction-create', onCreate);
      window.removeEventListener('vox-interaction-browse', onBrowse);
    };
  }, []);
  return (
    <>
      {create ? <InteractionComposer key={create.at} detail={create} onClose={() => setCreate(null)} /> : null}
      {browse ? <InteractionBrowser key={browse.at} detail={browse} onClose={() => setBrowse(null)} /> : null}
    </>
  );
}
